var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "data-component": "agent-status-item-settings" } },
    [
      _c("or-input", {
        attrs: {
          "data-input": "status-key",
          label: _vm.$t("hitl.settings.agent-status.key-label"),
          placeholder: _vm.$t("hitl.settings.agent-status.key-placeholder"),
          "model-value": _vm.item.key,
          required: true,
          maxlength: 256,
          disabled: _vm.item.isBasic,
          error: _vm.errors.key,
        },
        on: { input: _vm.onKeyChange },
      }),
      _vm._v(" "),
      _c("or-select", {
        attrs: {
          label: _vm.$t("hitl.settings.agent-status.status-label"),
          "model-value": _vm.item.status,
          options: _vm.statusOptions,
          disabled: true,
        },
        on: { "update:modelValue": _vm.onStatusChange },
      }),
      _vm._v(" "),
      _c("or-input", {
        attrs: {
          "data-input": "status-label",
          label: _vm.$t("hitl.settings.agent-status.description-label"),
          placeholder: _vm.placeholders.label,
          "model-value": _vm.item.label,
          required: true,
          maxlength: 256,
          disabled: _vm.item.isBasic,
          error: _vm.errors.label,
        },
        on: { "update:modelValue": _vm.onLabelChange },
      }),
      _vm._v(" "),
      _c("or-input", {
        attrs: {
          "data-input": "status-icon",
          label: _vm.$t("hitl.settings.agent-status.icon-label"),
          placeholder: _vm.placeholders.icon,
          "model-value": _vm.item.icon,
          maxlength: 256,
        },
        on: { input: _vm.onIconChange },
      }),
      _vm._v(" "),
      _c("or-input", {
        attrs: {
          "data-input": "status-expire-in",
          label: _vm.$t("hitl.settings.agent-status.expire-in-label"),
          placeholder: _vm.$t(
            "hitl.settings.agent-status.expire-in-placeholder"
          ),
          "model-value": _vm.expireInMinutes,
        },
        on: { input: _vm.onExpireInChange },
      }),
      _vm._v(" "),
      _c("or-checkbox", {
        attrs: {
          "data-checkbox": "status-toggle-on",
          "model-value": _vm.item.canToggle.includes("on"),
          label: _vm.$t("hitl.settings.agent-status.can-toggle-on-label"),
        },
        on: {
          "update:modelValue": function ($event) {
            return _vm.onCanToggleChange("on")
          },
        },
      }),
      _vm._v(" "),
      _c("or-checkbox", {
        attrs: {
          "data-checkbox": "status-toggle-off",
          label: _vm.$t("hitl.settings.agent-status.can-toggle-off-label"),
          "model-value": _vm.item.canToggle.includes("off"),
        },
        on: {
          "update:modelValue": function ($event) {
            return _vm.onCanToggleChange("off")
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }